import React from 'react';
import moment from 'moment';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Container, Header, Content, Footer } from 'rsuite';
import PosHeader from '../Header';

const StyledContent = styled(Content)`
  margin: 0 auto 70px;
  padding: 15px 5px 0;
  width: 100%;
  max-width: 950px;
`;

const StyledFooter = styled(Footer)`
  bottom: 0;
  z-index: 2;
  border-top: 1px solid #ddd;
  position: fixed;
  background: #efefef;
  margin: 0 auto;
  text-align: center;
  width: 100%;
  padding: 10px 0;
`;

function PosLayout({ children }) {
  return (
    <Container>
      <Header>
        <PosHeader />
      </Header>
      <StyledContent>{children}</StyledContent>
      <StyledFooter>
        Copyright &copy; {moment().format('Y')} FoodBank Manager by{' '}
        <strong>
          Sox Box
          <sup>®</sup>
        </strong>
      </StyledFooter>
    </Container>
  );
}

PosLayout.propTypes = {
  children: PropTypes.node.isRequired
};

export default PosLayout;
